module.exports = __webpack_public_path__ + "img/X-mind.0325765e.png";